import { destroyGameBgm } from "./gameBgm";
import { destroyMenuBgmElements } from "./menuBgm";

const LIVE_GAME = "__breakroomLiveGame";
const LIVE_CONTEXTS = "__breakroomAudioContexts";

type LiveGame = {
  destroy: (removeCanvas: boolean, noReturn?: boolean) => void;
  sound?: { stopAll?: () => void };
};

type LiveAudioHost = typeof globalThis & {
  [LIVE_GAME]?: LiveGame | null;
  [LIVE_CONTEXTS]?: AudioContext[];
};

export function registerLiveGame(game: LiveGame | null): void {
  (globalThis as LiveAudioHost)[LIVE_GAME] = game;
}

export function registerLiveAudioContext(context: AudioContext): void {
  const host = globalThis as LiveAudioHost;
  host[LIVE_CONTEXTS] ??= [];
  host[LIVE_CONTEXTS].push(context);
}

export function teardownLiveAudio(): void {
  destroyMenuBgmElements();
  destroyGameBgm();

  const host = globalThis as LiveAudioHost;
  const game = host[LIVE_GAME];
  try {
    game?.sound?.stopAll?.();
    game?.destroy(true);
  } catch {
    // Orphaned Phaser instances can already be mid-destroy during HMR.
  }
  host[LIVE_GAME] = null;

  for (const context of host[LIVE_CONTEXTS] ?? []) {
    try {
      void context.close();
    } catch {
      // Closing a used AudioContext is best-effort cleanup.
    }
  }
  host[LIVE_CONTEXTS] = [];

  for (const media of document.querySelectorAll<HTMLMediaElement>("audio,video")) {
    media.pause();
    media.muted = true;
    media.currentTime = 0;
    media.removeAttribute("src");
    media.load();
    media.remove();
  }
}
